import {defineMessages} from 'react-intl';

export default defineMessages({
    all: {
        defaultMessage: 'All',
        description: 'Tag for filtering a library for everything',
        id: 'gui.libraryTags.all'
    },
    animals: {
        defaultMessage: 'Animals',
        description: 'Tag for filtering a library for animals',
        id: 'gui.libraryTags.animals'
    },
    dance: {
        defaultMessage: 'Dance',
        description: 'Tag for filtering a library for dance',
        id: 'gui.libraryTags.dance'
    },
    effects: {
        defaultMessage: 'Effects',
        description: 'Tag for filtering a library for effects',
        id: 'gui.libraryTags.effects'
    },
    fantasy: {
        defaultMessage: 'Fantasy',
        description: 'Tag for filtering a library for fantasy',
        id: 'gui.libraryTags.fantasy'
    },
    fashion: {
        defaultMessage: 'Fashion',
        description: 'Tag for filtering a library for fashion',
        id: 'gui.libraryTags.fashion'
    },
    food: {
        defaultMessage: 'Food',
        description: 'Tag for filtering a library for food',
        id: 'gui.libraryTags.food'
    },
    indoors: {
        defaultMessage: 'Indoors',
        description: 'Tag for filtering a library for indoors',
        id: 'gui.libraryTags.indoors'
    },
    loops: {
        defaultMessage: 'Loops',
        description: 'Tag for filtering a library for loops',
        id: 'gui.libraryTags.loops'
    },
    themes: {
        defaultMessage: 'Themes',
        description: 'Tag for filtering a library for Themes',
        id: 'pm.libraryTags.themes'
    },
    music: {
        defaultMessage: 'Music',
        description: 'Tag for filtering a library for music',
        id: 'gui.libraryTags.music'
    },
    notes: {
        defaultMessage: 'Notes',
        description: 'Tag for filtering a library for notes',
        id: 'gui.libraryTags.notes'
    },
    outdoors: {
        defaultMessage: 'Outdoors',
        description: 'Tag for filtering a library for outdoors',
        id: 'gui.libraryTags.outdoors'
    },
    patterns: {
        defaultMessage: 'Patterns',
        description: 'Tag for filtering a library for patterns',
        id: 'gui.libraryTags.patterns'
    },
    people: {
        defaultMessage: 'People',
        description: 'Tag for filtering a library for people',
        id: 'gui.libraryTags.people'
    },
    percussion: {
        defaultMessage: 'Percussion',
        description: 'Tag for filtering a library for percussion',
        id: 'gui.libraryTags.percussion'
    },
    space: {
        defaultMessage: 'Space',
        description: 'Tag for filtering a library for space',
        id: 'gui.libraryTags.space'
    },
    sports: {
        defaultMessage: 'Sports',
        description: 'Tag for filtering a library for sports',
        id: 'gui.libraryTags.sports'
    },
    underwater: {
        defaultMessage: 'Underwater',
        description: 'Tag for filtering a library for underwater',
        id: 'gui.libraryTags.underwater'
    },
    voice: {
        defaultMessage: 'Voice',
        description: 'Tag for filtering a library for voice',
        id: 'gui.libraryTags.voice'
    },
    wacky: {
        defaultMessage: 'Wacky',
        description: 'Tag for filtering a library for wacky',
        id: 'gui.libraryTags.wacky'
    },
    animation: {
        defaultMessage: 'Animation',
        description: 'Tag for filtering a library for animation',
        id: 'gui.libraryTags.animation'
    },
    art: {
        defaultMessage: 'Art',
        description: 'Tag for filtering a library for art',
        id: 'gui.libraryTags.art'
    },
    games: {
        defaultMessage: 'Games',
        description: 'Tag for filtering a library for games',
        id: 'gui.libraryTags.games'
    },
    stories: {
        defaultMessage: 'Stories',
        description: 'Tag for filtering a library for stories',
        id: 'gui.libraryTags.stories'
    },
    letters: {
        defaultMessage: 'Letters',
        description: 'Tag for filtering a library for letters',
        id: 'gui.libraryTags.letters'
    },
    swords: {
        defaultMessage: 'Swords',
        description: 'Tag for filtering a library for swords',
        id: 'pm.libraryTags.swords'
    },
    guns: {
        defaultMessage: 'Guns',
        description: 'Tag for filtering a library for guns',
        id: 'pm.libraryTags.guns'
    },
    penguinmod: {
        defaultMessage: 'PenguinMod',
        description: 'Tag for filtering a library by PenguinMod',
        id: 'pm.libraryTags.penguinmod'
    },
    scratch: {
        defaultMessage: 'Scratch',
        description: 'Tag for filtering a library by Scratch',
        id: 'pm.libraryTags.scratch'
    },
    turbowarp: {
        defaultMessage: 'TurboWarp',
        description: 'Tag for filtering a library by TurboWarp',
        id: 'pm.libraryTags.turbowarp'
    },
    programminglanguage: {
        defaultMessage: 'Programming Languages',
        description: 'Tag for filtering a library by programminglanguage',
        id: 'pm.libraryTags.programminglanguage'
    },
    categoryexpansion: {
        defaultMessage: 'Category Expansions',
        description: 'Tag for filtering a library by categoryexpansion',
        id: 'pm.libraryTags.categoryexpansion'
    },
    ui: {
        defaultMessage: 'Menu',
        description: 'Tag for filtering a library by UI/Menu',
        id: 'pm.libraryTags.ui'
    },
    footsteps: {
        defaultMessage: 'Footsteps',
        description: 'Tag for filtering a library by footsteps',
        id: 'pm.libraryTags.footsteps'
    },
    custom: {
        defaultMessage: 'Custom',
        description: 'Tag for filtering a library by custom. Usually this is a custom button, not an actual tag',
        id: 'pm.libraryTags.custom'
    },
    customextension: {
        defaultMessage: 'Load Custom Extension',
        description: 'Button that loads a custom extension.',
        id: 'pm.libraryTags.customextension'
    },
    hardware: {
        defaultMessage: 'Hardware',
        description: 'Tag for filtering a library by hardware.',
        id: 'pm.libraryTags.hardware'
    },
    library: {
        defaultMessage: 'Collections',
        description: 'Tag for filtering a library by extension collections.',
        id: 'pm.libraryTags.library'
    },
    extcreate: {
        defaultMessage: 'Extension Creators',
        description: 'Tag for finding all extension creator programs / website',
        id: 'pm.libraryTags.extcreate'
    },
    datamgmt: {
        defaultMessage: 'Data Management',
        description: 'Tag for filtering a library by data management',
        id: 'pm.libraryTags.datamgmt'
    },
    graphics: {
        defaultMessage: 'Graphics',
        description: 'Tag for filtering a library by graphics.',
        id: 'pm.libraryTags.graphics'
    },
    noisemaker: {
        defaultMessage: 'Sound',
        description: 'Tag for filtering a library by their relation to sound.',
        id: 'pm.libraryTags.noisemaker'
    },
    metal: {
        defaultMessage: 'Metal',
        description: 'Tag for filtering a library by metal sounds.',
        id: 'pm.libraryTags.metal'
    },
    monsters: {
        defaultMessage: 'Monsters',
        description: 'Tag for filtering a library by monster sounds.',
        id: 'pm.libraryTags.monster'
    },
    math: {
        defaultMessage: 'Math',
        description: 'Tag for filtering a library by math.',
        id: 'pm.libraryTags.math'
    },
});
